/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-nested-ternary */
import 'styled-components/macro';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { TableRow } from 'components/atoms/TableRow';
import TableCell from 'components/atoms/TableCell';
import { useEffect, useState } from 'react';
import { StyledTable, TableHolder, TBody, TableScroll, Thead, NoRecordFound } from './Table.styles';
import Field from '../Field';

function Table({
  loading,
  columnNames,
  rowsData,
  height,
  center,
  sm,
  headSm,
  onClick = () => {},
  noPadding,
  width,
  responsive = true,
  isSelectable = false,
  onSelect = () => {},
  defaultSelectAll = false,
  ...props
}) {
  const [state, setState] = useState({
    checkedAll: false,
    checkedRows: [],
  });

  useEffect(() => {
    if (rowsData?.length > 0) {
      const checkedRows = rowsData?.map((row, index) => ({
        [index]: defaultSelectAll,
      }));
      setState(prev => ({ ...prev, checkedRows, checkedAll: !!defaultSelectAll }));
      if (defaultSelectAll) {
        onSelect(checkedRows);
      }
    }

    return () => {
      setState(prev => ({ ...prev, checkedAll: false, checkedRows: [] }));
    };
  }, [rowsData, defaultSelectAll]);

  const handleSelectAll = () => {
    if (state.checkedAll) {
      const checkedRows = rowsData?.map((row, index) => ({
        [index]: false,
      }));
      setState(prev => ({ ...prev, checkedAll: false, checkedRows }));
      onSelect(checkedRows);
    } else {
      const checkedRows = rowsData?.map((row, index) => ({ [index]: true }));
      setState(prev => ({ ...prev, checkedAll: true, checkedRows }));
      onSelect(checkedRows);
    }
  };

  const handleSelectRow = id => {
    const isChecked = state?.checkedRows[id][id];

    const updatedCheckedRows = [...state.checkedRows];
    state.checkedRows?.forEach(() => {
      if (isChecked) {
        updatedCheckedRows[id][id] = false;
      } else {
        updatedCheckedRows[id][id] = true;
      }
    });

    const isEvery = updatedCheckedRows.every((val, index) => val[index] === true);
    setState(prev => ({
      ...prev,
      checkedRows: updatedCheckedRows,
      checkedAll: isEvery,
    }));
    // onClick(updatedCheckedRows);
    onSelect(updatedCheckedRows);
  };
  return (
    <TableHolder responsive={responsive} noPadding={noPadding}>
      <TableScroll $height={height}>
        <StyledTable $width={width} responsive={responsive} {...props}>
          <Thead responsive={responsive}>
            <TableRow responsive={responsive}>
              {isSelectable && rowsData?.length > 0 && (
                <TableCell responsive={responsive} heading center={center} headSm={headSm}>
                  <Field
                    noMargin
                    type="checkbox"
                    label={<></>}
                    name="selectAll"
                    value={state?.checkedAll}
                    onChange={handleSelectAll}
                  />
                </TableCell>
              )}
              {columnNames.map((item, index) =>
                item === 'del' ? null : (
                  <TableCell responsive={responsive} heading key={index} center={center} headSm={headSm}>
                    {item}
                  </TableCell>
                ),
              )}
            </TableRow>
          </Thead>
          <TBody responsive={responsive}>
            {loading ? (
              Array(5)
                .fill()
                .map((item, i) => (
                  <TableRow key={i} responsive={responsive}>
                    {columnNames?.map(index => (
                      <TableCell responsive={responsive} key={index}>
                        <Skeleton width="100%" height={15} />
                      </TableCell>
                    ))}
                  </TableRow>
                ))
            ) : rowsData?.length ? (
              rowsData?.map((row, index) => (
                <TableRow
                  key={index}
                  onClick={() => onClick(row)}
                  responsive={responsive}
                  deleted={row?.includes('deleted')}>
                  {isSelectable && (
                    <TableCell heading center={center} headSm={headSm} sm={sm}>
                      <Field
                        noMargin
                        type="checkbox"
                        label={<></>}
                        name={index}
                        value={state?.checkedRows?.length ? state?.checkedRows[index]?.[index] : false}
                        onChange={() => {
                          handleSelectRow(index);
                        }}
                      />
                    </TableCell>
                  )}
                  {row?.map((el, i) =>
                    el === 'deleted' || el === 'false' ? null : (
                      <TableCell responsive={responsive} data-th={columnNames[i]} key={i} center={center} sm={sm}>
                        {el}
                      </TableCell>
                    ),
                  )}
                </TableRow>
              ))
            ) : (
              <tr
                css={`
                  @media (max-width: 991px) {
                    grid-column: span 2 / span 2;
                  }
                `}>
                <td
                  colSpan={columnNames?.length}
                  className="text-center"
                  css={`
                    @media (max-width: 991px) {
                      display: block;
                    }
                  `}>
                  <NoRecordFound>No Record Found</NoRecordFound>
                </td>
              </tr>
            )}
          </TBody>
        </StyledTable>
      </TableScroll>
    </TableHolder>
  );
}

export default Table;
